<body class="ltr main-body leftmenu">
    <form autocomplete="off" class="p-0" novalidate [formGroup]="BatchFreezeForm">
        <div class="main-content side-content pt-0 ml-0">
            <div class="main-container container-fluid">
                <div class="inner-body">
                    <div class="row row-sm add-form">
                        <div class="col-lg-12 col-md-12">
                            <div class="card custom-card">
                                <div class="card-body pb-0">
                                    <div class="col-md-12 prpl">
                                        <div class="row">
                                            <div class="col-md-5 prpl">
                                                <div class="d-flex align-items-center">
                                                    <img alt="Logo" src="../../assets/img/attendance.png"
                                                        class="mh-45px pb-2">
                                                    <p class="mb-1">
                                                        <span class="main-content-label"><b>Batch Freeze
                                                                Management</b></span><br>
                                                        <span class="text-muted card-sub-title mb-0">Manage Student
                                                            Batch Allocations</span>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <hr class="mt-2">

                                        <div class="row clearfix mt-2">
                                            <div class="col-sm-2">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>Session</mat-label>
                                                        <mat-select #select232 placeholder="Session" class="colorblack"
                                                            formControlName="SessionId">
                                                            <mat-select-filter *ngIf="select232.focused"
                                                                [placeholder]="'Filter'" [displayMember]="'SnName'"
                                                                [array]="sessionList"
                                                                (filteredReturn)="SessionFilterList = $event">
                                                            </mat-select-filter>
                                                            <mat-option *ngFor="let item of SessionFilterList"
                                                                [value]="item.SnNo" (click)="getCourse(item.SnNo)">
                                                                {{item.SnName}}
                                                            </mat-option>
                                                        </mat-select>
                                                        <mat-error
                                                            *ngIf="BatchFreezeForm.get('SessionId').hasError('required')">
                                                            Session is required
                                                        </mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>

                                            <div class="col-sm-2">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>Course</mat-label>
                                                        <mat-select #select55 class="colorblack"
                                                            formControlName="course">
                                                            <mat-select-filter *ngIf="select55.focused"
                                                                [placeholder]="'Filter'" [displayMember]="'CoName'"
                                                                [array]="CourseList"
                                                                (filteredReturn)="filteredListCourse = $event">
                                                            </mat-select-filter>
                                                            <mat-option *ngFor="let item of filteredListCourse"
                                                                [value]="item.CoCode" (click)="getCollege(item)">
                                                                {{item.CoCode}} - {{item.CoName}}
                                                            </mat-option>
                                                        </mat-select>
                                                        <mat-error
                                                            *ngIf="BatchFreezeForm.get('course').hasError('required')">
                                                            Course is required
                                                        </mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>

                                            <div class="col-sm-2">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>College</mat-label>
                                                        <mat-select #select23 formControlName="college"
                                                            [displayMember]="'CgName'">
                                                            <mat-select-filter *ngIf="select23.focused"
                                                                [placeholder]="'Filter'" [displayMember]="'CgName'"
                                                                [array]="collegeList"
                                                                (filteredReturn)="filteredCollegeList = $event">
                                                            </mat-select-filter>
                                                            <mat-option *ngFor="let item of filteredCollegeList"
                                                                [value]="item.CgCode">
                                                                {{item.CgCode}} - {{item.CgName}}
                                                            </mat-option>
                                                        </mat-select>
                                                        <mat-error
                                                            *ngIf="BatchFreezeForm.get('college').hasError('required')">
                                                            College is required
                                                        </mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>

                                            <div class="col-sm-2">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>Exam</mat-label>
                                                        <mat-select #select2398 placeholder="Exam"
                                                            formControlName="EmId">
                                                            <mat-select-filter *ngIf="select2398.focused"
                                                                [placeholder]="'Filter'" [displayMember]="'EmName'"
                                                                [array]="examList"
                                                                (filteredReturn)="filteredListExam = $event">
                                                            </mat-select-filter>
                                                            <mat-option *ngFor="let item of filteredListExam"
                                                                [value]="item.EmId" (click)="getSubject(item)">
                                                                {{item.EmCoCode}}-{{item.EmName}}
                                                            </mat-option>
                                                        </mat-select>
                                                        <mat-error
                                                            *ngIf="BatchFreezeForm.get('EmId').hasError('required')">
                                                            Exam is required
                                                        </mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>

                                            <div class="col-sm-2" *ngIf="isBranch">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>Branch</mat-label>
                                                        <mat-select #select23 placeholder="Branch"
                                                            formControlName="Branch">
                                                            <mat-select-filter *ngIf="select23.focused"
                                                                [placeholder]="'Filter'" [displayMember]="'EmName'"
                                                                [array]="BranchList"
                                                                (filteredReturn)="filteredListBranch = $event">
                                                            </mat-select-filter>
                                                            <mat-option *ngFor="let item of filteredListBranch"
                                                                [value]="item.StrId" (click)="getStr(item)">
                                                                {{item.StrName}}
                                                            </mat-option>
                                                        </mat-select>
                                                    </mat-form-field>
                                                </div>
                                            </div>

                                            <div class="col-sm-2">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>Subject</mat-label>
                                                        <mat-select #select2345 placeholder="Subject"
                                                            formControlName="EsParentId">
                                                            <mat-select-filter *ngIf="select2345.focused"
                                                                [placeholder]="'Filter'" [displayMember]="'EsName'"
                                                                [array]="subjectList"
                                                                (filteredReturn)="filteredsubjectList = $event">
                                                            </mat-select-filter>
                                                            <mat-option *ngFor="let item of filteredsubjectList"
                                                                [value]="item.EsId" (click)="subjectClick(item)">
                                                                {{item.EsCode}}-{{item.EsName}}
                                                            </mat-option>
                                                        </mat-select>
                                                        <mat-error
                                                            *ngIf="BatchFreezeForm.get('EsParentId').hasError('required')">
                                                            Subject is required
                                                        </mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>

                                            <div class="col-sm-2">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>Batches</mat-label>
                                                        <mat-select #select2387 placeholder="Batches"
                                                            formControlName="EsId">
                                                            <mat-select-filter *ngIf="select2387.focused"
                                                                [placeholder]="'Filter'" [displayMember]="'EsName'"
                                                                [array]="HeadList"
                                                                (filteredReturn)="filteredListHead = $event">
                                                            </mat-select-filter>
                                                            <mat-option *ngFor="let item of filteredListHead"
                                                                [value]="item.PbdBatchName" (click)="getHeadCode(item)">
                                                                {{item.PbdBatchName}}
                                                            </mat-option>
                                                        </mat-select>
                                                        <mat-error
                                                            *ngIf="BatchFreezeForm.get('EsId').hasError('required')">
                                                            Batch is required
                                                        </mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                        </div>

                                        <hr class="mt-2">

                                        <div class="row align-items-center">
                                            <div *ngIf="Table" class="col-sm-9">
                                                <div class="mb-3">
                                                    <!-- <p><b>Note: Select new batch for students from the dropdown. Changes
                                                            will be saved when you click Update.</b></p> -->
                                                    <p *ngIf="isFreezed" style="color: red;"><b>WARNING: Batches are
                                                            currently FROZEN. No changes can be made.</b></p>
                                                </div>
                                                <!-- <div *ngIf="message; else cut" class="mb-3">
                                                    <p style="color: green;"><b>{{message}}</b></p>
                                                </div>
                                                <ng-template #cut>
                                                    <div class="mb-3" *ngIf="closeMessage">
                                                        <p style="color: red;"><b>{{closeMessage}}</b></p>
                                                    </div>
                                                </ng-template> -->
                                            </div>

                                            <!-- <div *ngIf="Table" class="col-sm-3" [formGroup]="BatchFreezeForm">
                                                <mat-form-field appearance="outline" class="w-100">
                                                    <mat-label>Search</mat-label>
                                                    <input class="color" matInput placeholder="Search"
                                                        (keyup)="keypress()" formControlName="SearchString">
                                                    <mat-icon matSuffix>search</mat-icon>
                                                </mat-form-field>
                                            </div> -->
                                        </div>

                                        <div *ngIf="Table" class="table-responsive mt-4" style="overflow-x: auto;">
                                            <div class="container-fluid">
                                                <table class="table table-bordered text-center"
                                                    style="min-width: 800px;">
                                                    <thead class="text-center">
                                                        <tr>
                                                            <th style="min-width: 60px; width: 60px;">Sr.No</th>
                                                            <th style="min-width: 300px; width: 300px;">Student Name
                                                            </th>
                                                            <th style="min-width: 150px; width: 150px;">PRN Number</th>
                                                            <th style="min-width: 150px; width: 150px;">Current Batch
                                                            </th>
                                                            <th style="min-width: 200px; width: 200px;">Change Batch
                                                            </th>
                                                        </tr>
                                                    </thead>

                                                    <tbody formArrayName="StuArray">
                                                        <tr *ngFor="let studentCtrl of getStuArrayControls(); let i = index"
                                                            [formGroupName]="i">

                                                            <td style="width: 60px;">{{ i + 1 }}</td>

                                                            <td
                                                                style="width: 300px; text-align: left; padding-left: 10px;">
                                                                {{ studentCtrl.get('Name').value }}
                                                            </td>

                                                            <td style="width: 150px;">
                                                                {{ studentCtrl.get('StuRgNo').value }}
                                                            </td>

                                                            <td style="width: 150px;">
                                                                <span class="badge badge-info">
                                                                    Batch {{ assignTableData[i].PbdBatchName }}
                                                                </span>
                                                            </td>

                                                            <td style="width: 200px; padding: 8px;">
                                                                <mat-form-field appearance="outline"
                                                                    style="width: 100%;">
                                                                    <mat-label>Change Batch</mat-label>
                                                                    <mat-select #selectBatch
                                                                        formControlName="NewBatchNo"
                                                                        [disabled]="isFreezed"
                                                                        (selectionChange)="onBatchChange(i, $event.value)">
                                                                        <mat-select-filter *ngIf="selectBatch.focused"
                                                                            [placeholder]="'Filter'"
                                                                            [displayMember]="'PbdBatchName'"
                                                                            [array]="batchList"
                                                                            (filteredReturn)="filteredBatchList = $event">
                                                                        </mat-select-filter>
                                                                        <mat-option
                                                                            *ngFor="let batch of filteredBatchList"
                                                                            [value]="batch.PbdBatchNo">
                                                                            {{ batch.PbdBatchName }}
                                                                        </mat-option>
                                                                    </mat-select>
                                                                </mat-form-field>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>

                                    </div>

                                    <div class="col-sm-12">
                                        <button type="button"
                                            class="btn size1 btn-warning btn-icon-text floatright mr-3 mt-1"
                                            *ngIf="FreezeBtn && !isFreezed" (click)="freezeBatches()">
                                            <span style="display: contents; align-items: center;">
                                                <i class="fas fa-lock mr-2"></i>
                                                Freeze Batches
                                            </span>
                                        </button>

                                        <button type="button" *ngIf="UpdateBtn" [disabled]="updateDisable || isFreezed"
                                            class="btn size1 btn-primary btn-icon-text floatright mr-3 mt-1"
                                            (click)="update()">
                                            <span style="display: contents; align-items: center;">
                                                <img width="15vh" src="../../assets/img/edit1.gif"
                                                    style="margin-right: 7px;">
                                                Update Batches
                                            </span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</body>